<template>
  <div
    class="guess_like"
    v-if="guessLike.length"
    :class="[
      hide_container ? '' : 'container',
      {
        'inline-guesslike': inline_cart || pc_to_mb,
        'vogue-guess-ligke': theme == 'vogue',
        'athena-guess-ligke': theme == 'athena',
      },
    ]"
  >
    <h3
      class="guess_title"
      :class="{
        'justify-content-md-between justify-content-center': theme == 'athena',
      }"
    >
      <span class="title_font2">{{ recommended_product.title }}</span>
      <em
        @click="change_like({refresh:'yes'})"
        class="secondary_title"
        :class="{ 'd-md-block d-none': theme == 'athena' }"
        >{{ $t("recommend.no_like_this") }}</em
      >
    </h3>
    <div class="guess_list_wrap">
      <button
        class="prev"
        @click="prev"
        v-if="!inline_cart && !pc_to_mb"
        v-show="!slides == 0"
        ref="prev"
      >
        <svg viewBox="0 0 100 100">
          <path
            d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z"
            class="arrow"
          ></path>
        </svg>
      </button>
      <button
        class="next"
        @click="next"
        v-if="!inline_cart && !pc_to_mb"
        v-show="slides < click_num"
        ref="next"
      >
        <svg viewBox="0 0 100 100">
          <path
            d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z"
            class="arrow"
            transform="translate(100, 100) rotate(180) "
          ></path>
        </svg>
      </button>
      <div class="guess_list_hidden" v-if="!swiper_style">
        <ul v-if="inline_cart || pc_to_mb" class="inline-guesslike-list_box">
          <li
            v-for="(item, index) in guessLike"
            :key="item.ID"
            v-show="inlineCartNum > index"
          >
            <v-addCard
              :comment="plugConfig.Comment"
              :show_name="show_name"
              :show_one_line="show_one_line"
              :show_tag="show_tag"
              :show_add_btn="show_add_btn"
              :product="item"
              :variants="variants[index]"
              :recommended_product="recommended_product"
              :addcart="addcart"
              :addproduct="addproduct"
              :index="index"
              :selectvariants="selectvariants"
              :card_type="card_type"
            ></v-addCard>
          </li>
          <li
            v-show="guessLike.length > 3 && inlineCartNum !== 999"
            @click="inlineCartNum = 999"
            class="text-center"
            style="margin-top: 12px; margin-bottom: 20px; cursor: pointer"
          >
            {{ $t("filter.view_more") }}
            <!-- <svg
              viewBox="0 0 100 100"
              style="height: 11px; transform: translateY(-2px) rotate(270deg)"
            >
              <path
                d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z"
                class="arrow"
              ></path>
            </svg> -->
            <span class="icon-xiajiantou1 iconfont" style="font-size: 14px"></span>
          </li>
        </ul>
        <ul
          @touchstart="startMove"
          @touchend="endMove"
          class="guess_list_box clearfix"
          ref="guess_list_box"
          v-else
        >
          <template v-if="theme != 'athena'">
            <li
              class="guess_list_item"
              ref="guess_list_item"
              v-for="(item, index) in guessLike"
              :key="item.ID"
            >
              <div class="item_gallery">
                <a :href="item.path || item.public_url" ref="guess_list_a">
                  <v-img-card
                    :card_type="card_type"
                    :data_url="getProductImage(index,'url')"
                    :data_src="getProductImage(index,'thumbnail')"
                    :load="computed_position"
                    :use_product_card_config="true"
                  ></v-img-card>
                  <span
                    class="sale_tag saveprice_tag secondary_title"
                    v-if="
                      show_tag &&
                      variants[index].price - 0 <
                        variants[index].regular_price - 0
                    "
                    >-{{
                      100 -
                      Math.round(
                        ((variants[index].price - 0) /
                          (variants[index].regular_price - 0)) *
                          100
                      )
                    }}%</span
                  >
                </a>
              </div>
              <div class="item_name" v-if="show_name">
                <a
                  class="page_text_font"
                  :href="item.path || item.public_url"
                  :title="item.post_title"
                  :class="show_one_line ? 'oneline' : ''"
                  >{{ item.post_title }}</a
                >
              </div>
              <div
                v-if="show_add_btn && !palette_config"
                class="item_attribute"
                :class="{
                  has_select: item.variants_detail && item.variants_detail.length > 1,
                }"
              >
                <template v-if="item.variants_detail && item.variants_detail.length > 1">
                  <select
                    v-model="addproduct[index].variant_id"
                    @change="selectvariants(item, index)"
                    class="secondary_title guesslike-select"
                  >
                    <option
                      v-for="subitem in item.variants_detail"
                      :key="subitem.ID"
                      :value="subitem.ID"
                    >
                      <span
                        v-for="(option, optionindex) in subitem.attrs"
                        :key="subitem.ID + optionindex + option.value"
                        >{{
                          optionindex == subitem.attrs.length - 1
                            ? option.value
                            : option.value + " / "
                        }}</span
                      >
                    </option>
                  </select>
                </template>
              </div>
              <p class="item_price">
                <v-selectprice
                  :price="variants[index].price"
                  :font-size="14"
                  :regular-font-size="14"
                  :regular_price_num="
                    variants[index].price - 0 <
                    variants[index].regular_price - 0
                      ? variants[index].regular_price
                      : 0
                  "
                  :disable_select="true"
                  :currency_style="currency_style"
                  :country="
                    !show_currency_selector ? '' : $store.state.pricetype
                  "
                  :show_country="false"
                ></v-selectprice>
              </p>
              <div class="item_star" v-if="plugConfig.Comment&&item.review_status&&item.review_status=='open' && show_star" :style="{'visibility':!(show_star === 'only' && Number(item.review_count) === 0)?'visible':'hidden'}">
                <v-comments-star
                  :disabled="true"
                  :average_rating="item.average_rating"
                  font_size="18"
                ></v-comments-star
                >({{ item.review_count }})
              </div>
              <div v-if="show_add_btn" style="position:relative" v-clickoutside="()=>{show_palette_btn[`b-${index}`] = false}">
                <!-- pc调色板加购弹窗 -->
                <div
                class="attribute-pupup"
                v-if="
                palette_config &&
                product_palette_list[item.ID] &&
                product_palette_list[item.ID].length &&
                show_palette_btn[`b-${index}`] &&
                !isMb
                "
                >
                  <!-- 变种属性 -->
                  <div class="attribute-pupup__palette">
                    <v-product-palette
                      @click.native="change_selected_variant_attrs($event, index)"
                      type="detail"
                      :palette_attrs="product_palette_list[item.ID]"
                      :variant_attrs="selected_variant_attrs[index]"
                      :palette_config="palette_config"
                      :isPopup="true"
                    />
                    <!-- 关闭图标 -->
                    <i class="iconfont icon-cm-cancel-1-copy" @click="showPaletteBtn(index,false)"></i>
                  </div>
                  <!-- 添加购物车按钮 -->
                  <button
                   class="item_button main_button"
                   :class="{ 'item_button--loading': adding[`b-${index}`] }"
                   v-if="variants[index].buy_able"
                   @click="addcart(index)"
                  >
                    <i class="iconfont icon-gouwuche" />
                    <span class="secondary_title text-uppercase">{{
                    $t("recommend.add_to_cart")
                    }}</span>
                  </button>
                  <button v-else class="item_button" id="slodout">
                    <span class="secondary_title text-uppercase">{{
                      $t("detail.sold_out")
                    }}</span>
                  </button>
                </div>

                <!-- mb调色板加购弹窗 -->
                <div v-if="isMb">
                  <el-drawer
                    :visible.sync="show_palette_btn[`b-${index}`]"
                    direction="btt"
                    :with-header="false"
                    append-to-body
                    class="attribute-pupup-mb"
                  >
                    <!-- 图片、名称 -->
                    <div class="attribute-pupup-mb__head">
                      <div class="acpc-head-left">
                        <v-lazy-img
                          :data-url="
                            (variants[index] &&
                              variants[index].feature_image &&
                              variants[index].feature_image.url) ||
                            (item.feature_image && item.feature_image.url)
                          "
                          :src="
                            (variants[index] &&
                              variants[index].feature_image &&
                              variants[index].feature_image.thumbnail) ||
                            (item.feature_image && item.feature_image.thumbnail)
                          "
                          alt=""
                        />
                      </div>
                      <div class="acpc-head-right">
                        <h5 class="text-overflow-2">
                          {{ item.post_title || item.title }}
                        </h5>
                        <h6 class="text-overflow-1">
                          {{ item.subtitle }}
                        </h6>
                        <div>
                          <v-simplePrice
                            mode="regular_price"
                            v-if="variants[index].price < variants[index].regular_price"
                            :price="variants[index].regular_price"
                          ></v-simplePrice>
                          <v-simplePrice :price="variants[index].price"></v-simplePrice>
                        </div>
                      </div>
                    </div>
                    <!-- 变种属性 -->
                    <div class="attribute-pupup-mb__palette">
                    <v-product-palette
                      @click.stop.native="change_selected_variant_attrs($event, index)"
                      type="detail"
                      :palette_attrs="product_palette_list[item.ID]"
                      :variant_attrs="selected_variant_attrs[index]"
                      :palette_config="palette_config"
                    />
                    </div>
                    <!-- 添加购物车按钮 -->
                    <div class="attribute-pupup-mb__button-box">
                      <button
                       class="attribute-pupup-mb__item_button main_button"
                       :class="{ 'attribute-pupup-mb__item_button--loading': adding[`b-${index}`] }"
                       v-if="variants[index].buy_able"
                       @click="addcart(index)"
                      >
                        <i class="iconfont icon-gouwuche" />
                        <span class="secondary_title text-uppercase">
                          {{ $t("recommend.add_to_cart") }}
                        </span>
                      </button>
                      <button v-else class="attribute-pupup-mb__item_button" id="slodout">
                        <span class="secondary_title text-uppercase">{{
                          $t("detail.sold_out")
                        }}</span>
                      </button>
                    </div>
                  </el-drawer>
                </div>

                <!-- pc调色板弹窗按钮 -->
                <button
                  class="item_button transition-main"
                  :class="{ 'item_button--loading': adding[`b-${index}`] }"
                  v-if="
                        palette_config &&
                        product_palette_list[item.ID] &&
                        product_palette_list[item.ID].length &&
                        !show_palette_btn[`b-${index}`]"
                  @click="showPaletteBtn(index,true)"
                >
                  <i class="iconfont icon-gouwuche" />
                  <span class="secondary_title text-uppercase">{{
                    $t("recommend.add_to_cart")
                  }}</span>
                </button>

                <button
                  class="item_button main_button"
                  :class="{ 'item_button--loading': adding[`b-${index}`] }"
                  v-else-if="variants[index].buy_able"
                  @click="addcart(index)"
                >
                  <i class="iconfont icon-gouwuche" />
                  <span class="secondary_title text-uppercase">{{
                    $t("recommend.add_to_cart")
                  }}</span>
                </button>
                <button v-else class="item_button" id="slodout">
                  <span class="secondary_title text-uppercase">{{
                    $t("detail.sold_out")
                  }}</span>
                </button>
              </div>
            </li>
          </template>
          <template v-else>
            <li
              class="guess_list_item"
              ref="guess_list_item"
              v-for="(item, index) in guessLike"
              :key="item.ID + '' + index"
            >
              <v-product-card
                addType="guessLike"
                :disable_select="true"
                :show_currency_selector="show_currency_selector"
                :cart_type="cart_type"
                :theme="theme"
                card_animate="vogue-am"
                text_align="left"
                :show_star="true"
                :productDetail="item"
                :custom_button="
                  item.custom_button && item.custom_button.custom_button
                "
                model="is_card"
                :palette_config="palette_config"
                combination_position="guesslike"
              ></v-product-card>
            </li>
          </template>
        </ul>
      </div>
      <div class="guess_list_hidden" v-if="swiper_style">
        <swiper class="swiper" :ref="swiperRef ? swiperRef : 'mark'" :options="swiperOption" @slideChangeTransitionEnd="slideChange">
          <swiper-slide class="stop-swipingasd" v-for="item in guessLike" :key="item.ID">
            <v-guesslike-card
              :disable_select="true"
              :show_currency_selector="show_currency_selector"
              :cart_type="cart_type"
              theme="athena"
              card_animate="vogue-am"
              text_align="left"
              :show_star="plugConfig.Comment&&item.review_status&&item.review_status=='open'"
              :productDetail="item"
              :custom_button="item.custom_button && item.custom_button.custom_button"
              model="is_card"
              :palette_config="palette_config"
            ></v-guesslike-card>
          </swiper-slide>
        </swiper>
        <div
          class="swiper-command swiper-pagination-clickable swiper-pagination-bullets"
          :class="{ 'swiper-pagination-command': !swiperRef, 'swiper-pagination-command2': swiperRef }"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import getSymbolFromCurrency from "currency-symbol-map";
import googleAnalysis from '@/js/lib/ga';
import { mapActions, mapState } from 'vuex';
import mixClose from '@/js/mixins/mixClose';
import vCommentsStar from "../comments/commentsstar";
import vAddCard from "../../../components/common/addCard.vue";
import vProductCard from "../../../../views/venue/js/view/collections/ProductCard.vue";
import vGuesslikeCard from "../../../../views/venue/js/view/collections/guesslikeCard.vue";
import vProductPalette from '@/js/components/view/productpalette/index.vue'
import vImgCard from '@/js/components/common/imgCard.vue';
export default {
  props: {
    // comment: {}, 直接从vuex中取评论配置和开关
    recommended_product: {},
    cart_type: {}, //购物车类型,若为inCart 则不跳转页面,并且在pc端切换至移动端时候转换为移动端样式
    product_id: {},//购物车商品id，或详情页商品id
    show_currency_selector: {},
    theme: {},
    currency_style: {},
    palette_config: {},
    card_type: {},
    inline_cart: {}, //始终显示移动端推荐商品
    hide_container: {}, //隐藏container
    onAdded: {}, // 加购后，回调
    combination_config: false,
    swiperRef:{}, // 区分swiper
    swiper_style: {}, // 是否使用轮播样式
  },
  data() {
    return {
      guessLike: [],
      addproduct: [],
      variants: [],
      // defaultImage,
      slides: 0,
      getSymbolFromCurrency: "",
      guess_list_box: 0, //ul盒子宽度
      guess_list_item: 0, //li宽度
      box_left: 0, //当前left值
      base_num: 0, //每次展示个数
      click_num: 0, //列表数量/每次展示个数-1等于可点击次数
      offset_num: 0, //超过可点击次数后展示偏移展示位置
      startX: 0,
      endX: 0,
      selected_variant_attrs: [],
      pc_to_mb: false,
      inlineCartNum: 3,
      swiperOption: null,
      adding: {},
      show_palette_btn: {},
      guess_like_ids:[],//当前推荐商品的id
      isMb:false,
    };
  },
  mixins:[mixClose],
  methods: {
    //
    getProductImage(index,filed='url'){
      const imageData = this.variants?.[index]?.feature_image || this.guessLike?.[index]?.feature_image
      if(imageData){
        return imageData[filed] != '' ? imageData[filed] : ''
      }else{
        return ''
      }
    },
    computed_position() {
      let gallery_img = this.$(this.$refs.guess_list_a);
      if (gallery_img && gallery_img.length) {
        let top = gallery_img.height() / 2 - 8;
        if (top > 0) {
          top = top + "px";
          this.$(this.$refs.next).css({ top });
          this.$(this.$refs.prev).css({ top });
        }
      }

      if (this.cart_type == "inCart" && window.innerWidth < 768) {
        this.pc_to_mb = true;
      } else {
        this.pc_to_mb = false;
      }

      if(window.innerWidth < 768) {
        this.isMb = true;
      } else {
        this.isMb = false;
      }
    },
    /**
     * 选中变种
     * 后根据选中的属性信息，循环找出产品的中对应的变种
     */
    change_selected_variant_attrs(event, index) {
      setTimeout(() => {
        this.guessLike[index].variants_detail.some((item) => {
          let res = item.attrs.every((subitem) => {
            // 检查已经选中的是否匹配
            return this.selected_variant_attrs[index].some((lowitem) => {
              return (
                lowitem.name == subitem.name && lowitem.value == subitem.value
              );
            });
          });
          if (res) {
            // 如果变种商品有图片则切换轮播图
            // 将variants的第[index]的数据换成
            this.variants.splice(index, 1, item);
            this.addproduct[index].variant_id = item.ID;
            return true;
          } else {
            this.addproduct[index].variant_id = null;
            this.variants.splice(index, 1, {
              buy_able: false,
            });
          }
        });
      }, 0);
    },
    prev() {
      this.slides--;
      this.complete_num();
      if (this.slides <= 0) {
        this.$(this.$refs.guess_list_box).animate(
          {
            left: "0px",
          },
          300
        );
        this.slides = 0;
      } else {
        this.$(this.$refs.guess_list_box).animate(
          {
            left: `${this.box_left + this.guess_list_box}px`,
          },
          300
        );
      }
    },
    complete_num() {
      this.guess_list_box = this.$(this.$refs.guess_list_box).width();
      let list_item = this.$(this.$refs.guess_list_item).css("width");
      if (list_item.includes("%")) {
        this.guess_list_item = list_item.replace("%", "") - 0;
        this.base_num = parseInt(100 / this.guess_list_item);
      } else if (list_item.includes("px")) {
        this.guess_list_item = list_item.replace("px", "") - 0;
        this.base_num = this.guess_list_box / this.guess_list_item; //每次展示个数
      }
      this.box_left = this.$(this.$refs.guess_list_box).position().left;
      this.click_num = Math.ceil(this.guessLike.length / this.base_num) - 1; //列表数量/每次展示个数-1等于可点击次数
      this.offset_num = this.guessLike.length % this.base_num; //超过可点击次数后展示偏移展示位置
    },
    next() {
      this.slides++;
      this.complete_num();
      if (this.slides <= this.click_num) {
        this.$(this.$refs.guess_list_box).animate(
          {
            left: `${this.box_left - this.guess_list_box}px`,
          },
          300
        );
      } else {
        this.$(this.$refs.guess_list_box).animate(
          {
            left: `${
              this.box_left -
              this.guess_list_box +
              this.offset_num * this.guess_list_item
            }px`,
          },
          300
        );
      }
    },
    async change_like(payload={}) {
      const _this = this;
      const CancelToken = this.$axios.CancelToken;
      this.cancelTokenFn && this.cancelTokenFn();
      this.cancelTokenFn = null;
      try {
        let res = await this.$axios.get("/api/store/recommended-products", {
          params: {
            ids: this.product_id,
            ...payload
          },
          cancelToken: new CancelToken(function executor(c) {
            _this.cancelTokenFn = c;
          }),
        });
        this.guessLike = res.data;
        this.guess_like_ids = this.guessLike.map((item) => {
          return item.ID
        })
        // if(this.combination_config){
        //   let arr_id = [];
        //   this.guessLike.forEach((item) => {
        //   arr_id.push(item.ID);
        //   });
        //   this.get_combination_list(arr_id);
        // }
        this.variants = [];
        this.addproduct = [];
        this.selected_variant_attrs = [];
        this.guessLike.forEach((item) => {
          if (item.variants_detail && item.variants_detail.length) {
            this.variants.push(item.variants_detail[0]);
            let attrs = JSON.stringify(item.variants_detail[0].attrs);
            this.selected_variant_attrs.push(JSON.parse(attrs));
            this.addproduct.push({
              quantity: "1",
              product_id: item.ID,
              variant_id: item.variants_detail[0].ID,
            });
          } else {
            this.selected_variant_attrs.push({});
            this.addproduct.push({
              quantity: "1",
              product_id: item.ID,
            });
            this.variants.push(item);
          }
        });
        if (this.guessLike.length && !this.inline_cart) {
          this.$nextTick(this.complete_num);
        }
      } catch (error) {
        if (
          error?.response?.data?.message
        ) {
          this.$message.error(error.response.data.message);
        }
      }
    },

    showPaletteBtn(index,bool) {
      if(typeof index != 'number') {
         this.show_palette_btn = {}
         return;
      }
      this.show_palette_btn = {
        ...this.show_palette_btn,
        [`b-${index}`]: bool
      }
    },

    // 加购事件可能还来自子组件addCard, type用于区分两者的loadin
    async addcart(index, type = 'thisPage') {
      if (type === 'thisPage') {
        if (this.adding[`b-${index}`]) return;

        this.adding = {
          ...this.adding,
          [`b-${index}`]: true
        }
      }
      // 加购之前事件
      if (this.beforeAdd) this.beforeAdd()

      try {
        let res = await this.$axios.post(API.addcart, {...this.addproduct[index],addType:"guessLike"});
        if (window.fbq) {
          let content_category = [];
          if (
            this.guessLike[index].categories &&
            this.guessLike[index].categories.length
          ) {
            this.guessLike[index].categories.forEach((item) => {
              content_category.push(item.name);
            });
          }
          this.send_fb_event("AddToCart", {
            content_type: "product_group",
            content_ids: [this.addproduct[index].product_id],
            value: this.variants[index].price,
            num_items: this.addproduct[index].quantity,
            content_name: this.variants[index].title,
            currency: window.checkoutcurrency || 'USD',
            content_category,
          });
        }
        if (window.ttq && window.send_ttp_event) {
          window.send_ttp_event('AddToCart', {
            content_id: [this.addproduct[index].product_id],
            quantity: this.addproduct[index].quantity,
            value: this.variants[index].price,
            currency: window.checkoutcurrency || 'USD',
          })
        }
        if (window._learnq) {
          this.klaviyo_addtocart(this.guessLike[index], this.addproduct[index]);
        }
        if (window.snaptr) {
          window.snaptr('track', 'ADD_CART', {
            'currency': window.checkoutcurrency || 'USD',
            'item_category': null,
            'item_ids': [this.addproduct[index].product_id],
            'number_items': this.addproduct[index].quantity,
            'price': this.variants[index].price,
          })
        }
        // if (window.gtag) {
        //   window.gtag("event", "add_to_cart");
        // }
        // 添加到购物车
        googleAnalysis.event(googleAnalysis.gaAction.add)

        this.$store.dispatch("cartContentsCount", res.data.cart_contents_count);
        localStorage.setItem("cartContentsCount", res.data.cart_contents_count);
        this.$store.dispatch("change_news_cart", res.data);
        if(res.data){
          this.$store.commit("change_button_disabled", true);
        }
        // 加购回调
        if (this.onAdded) this.onAdded({productId: this.addproduct[index]?.product_id});
        let pathname = window.location.pathname;
        if (type === 'thisPage') {
          this.adding[`b-${index}`] = false;
        }
        if(this.show_palette_btn) {
          this.show_palette_btn= {};
        }
        if (this.cart_type == "inCart") return;

        if (
          (this.theme == "Brooklyn" || this.theme == "showtime") &&
          this.cart_type == "drawer"
        ) {
          if (this.theme == "Brooklyn") {
            this.$store.dispatch("change_cart_type", true);
            this.$store.commit("change_button_disabled", false);
          }
          if (this.theme == "showtime") {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            this.$("#collapseExample").collapse("show");
          }
        } else if (
          (this.theme == "venue" || this.theme == "showtime") &&
          this.cart_type == "popup"
        ) {
          this.$("#modalCart").modal("show");
        } else if (
          this.theme == "vogue" &&
          (this.cart_type == "drawer" || this.cart_type == "popup")
        ) {
          this.showInlineCart();
        } else if (pathname != "/cart"){
          if(this.theme !== 'Brooklyn'){
            window.open("/cart", "_self");
          }
        }
        setTimeout(() => {
          this.$store.commit("change_button_disabled", false);
        }, 1000)
      } catch (error) {
        this.$store.commit("change_button_disabled", false);
        if (
          error?.response?.data?.errors
        ) {
          this.$message.error(Object.values(error.response.data.errors)[0][0]);
        } else if (error?.response?.data?.message) {
          this.$message.error(error.response.data.message);
        }
      }

    },
    selectvariants(item, index) {
      if (this.guessLike[index].variants_detail) {
        this.guessLike[index].variants_detail.some((item) => {
          if (item.ID == this.addproduct[index].variant_id) {
            this.variants.splice(index, 1, item);
            return true;
          }
        });
      }
    },
    startMove(e) {
      this.startX = e.targetTouches[0].clientX; // 获取触控时x坐标
    },
    endMove(e) {
      if (this.theme == "vogue" || this.theme == "athena") return;
      this.endX = e.changedTouches[0].clientX;
      if (this.distance > 50) {
        this.prev();
      } else if (this.distance < -50 && this.slides < this.click_num) {
        this.next();
      }
    },
    slideChange() {
      this.bus.$emit('guesslike_cart_slide_swiper');
    },
    ...mapActions({
      get_combination_list: 'get_combination_list', // 将 `this.get_product_tag()` 映射为 `this.$store.dispatch('change_product_tag_list')`
      get_product_palette: "get_product_palette", //获取产品调色板
    }),
  },
  beforeMount() {
    this.getSymbolFromCurrency = getSymbolFromCurrency;
    this.change_like();
    const options = {
      pagination: {
        el: this.swiperRef?".swiper-pagination-command2":".swiper-pagination-command",
        clickable: true,
      },
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
    };
    this.swiperOption = options;
  },
  mounted() {
    this.$(window).resize(this.computed_position);
  },
  watch: {
    guess_like_ids:{
      handler(newV){
        if(this.combination_config){
          this.get_combination_list({
            'filter[product_ids]':newV.join(','),
            combination_position: "guesslike"
          });
        }
        if (this.palette_config && this.palette_config.show_position == 'all') {
          this.get_product_palette(newV.join(','));
        }
      },
    },
    product_id:{
      handler(newV){
        if(!this.guessLike.length){
          this.change_like()
        }
      }
    }
  },

  computed: {
    // 手指触碰与离开的差值
    distance() {
      return this.endX - this.startX;
    },
    show_name() {
      return this.recommended_product.displayProductName != "0";
    },
    show_one_line() {
      return this.recommended_product.displayProductName == "2";
    },
    show_tag() {
      return this.recommended_product.tag != "0";
    },
    show_add_btn() {
      return this.recommended_product.addCartButton != "0";
    },
    ...mapState({
      // 产品卡片评论星星配置
      show_star: ({ options }) => options?.theme?.global?.product_cart?.show_star,
      plugConfig: ({ plugConfig }) => plugConfig,
      product_palette_list:({  product_palette_list}) => product_palette_list,
    }),
  },
  components: {
    vCommentsStar,
    vAddCard,
    vProductCard,
    vGuesslikeCard,
    vProductPalette,
    vImgCard,
  },
};
</script>
<style lang='scss'>
.attribute-pupup-mb {
  z-index: 9999999999 !important; // 为了防止被其他组件影响，弹窗类组件层级默认设置最高
  .el-drawer {
    height: auto !important;
    max-height: 80%;
  }
}
</style>
<style scoped lang='scss'>
.guess_like {
  position: relative;
  margin-bottom: 60px;
  .guess_title {
    font-size: 24px !important;
    line-height: 36px !important;
    color: #2f2f2f;
    padding: 20px 0;
    margin: 0;
    text-align: left;
    text-transform: capitalize;
    font-weight: 400;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    span {
      margin: 0;
      -webkit-tap-highlight-color: transparent;
      display: inline-block;
      // max-width: 70%;
      padding: 0;
      font-weight: 400;
      white-space: pre-wrap;
    }
    em {
      min-width: 100px;
      font-style: italic;
      font-weight: 400;
      margin: 0;
      padding: 0;
      -webkit-tap-highlight-color: transparent;
      font-size: 14px;
      cursor: pointer;
      text-decoration: underline;
    }
  }
  .guess_list_wrap {
    & > .prev,
    & > .next {
      position: absolute;
      width: 45px;
      height: 45px;
      border: none;
      border-radius: 50%;
      background: #fff;
      color: #000;
      cursor: pointer;
      text-align: center;
      z-index: 2;
      -webkit-box-shadow: 0 2px 10px rgb(54 54 54 / 15%);
      box-shadow: 0 2px 10px rgb(54 54 54 / 15%);
      vertical-align: middle;
      line-height: 0;
      -webkit-transform: scale(1.001);
      transform: scale(1.001);
      top: 35%;
      -webkit-transition: background 0.15s ease-in-out,
        opacity 0.15s ease-in-out, color 0.2s ease-in-out,
        -webkit-transform 0.2s ease-in-out;
      transition: background 0.15s ease-in-out, opacity 0.15s ease-in-out,
        color 0.2s ease-in-out, -webkit-transform 0.2s ease-in-out;
      transition: background 0.15s ease-in-out, opacity 0.15s ease-in-out,
        transform 0.2s ease-in-out, color 0.2s ease-in-out;
      transition: background 0.15s ease-in-out, opacity 0.15s ease-in-out,
        transform 0.2s ease-in-out, color 0.2s ease-in-out,
        -webkit-transform 0.2s ease-in-out;
      overflow: hidden;
      svg {
        width: auto;
        height: 18px;
        stroke-width: 10px;
        stroke: currentColor;
      }
      &:hover {
        transform: scale(1.1);
      }
    }
    & > .prev {
      left: -50px;
      &:hover {
        svg {
          -webkit-animation: buttonFromRightToLeft 0.5s ease-in-out forwards;
          animation: buttonFromRightToLeft 0.5s ease-in-out forwards;
        }
      }
    }
    & > .next {
      right: -50px;
      &:hover {
        svg {
          -webkit-animation: buttonFromLeftToRight 0.5s ease-in-out forwards;
          animation: buttonFromLeftToRight 0.5s ease-in-out forwards;
        }
      }
    }
    margin: 0 auto;
    position: relative;
    padding: 0;
    .guess_list_hidden {
      overflow: hidden;
      .inline-guesslike-list_box {
        margin: 0;
        padding: 0;
        li {
          list-style: none;
          margin-bottom: 10px;
        }
      }
    }
    .guess_list_box {
      margin: 0;
      padding: 0;
      position: relative;
      z-index: 1;
      box-sizing: content-box;
      outline: 0;
      display: flex;
      left: 0px;
      .guess_list_item {
        flex-shrink: 0;
        list-style: none;
        width: 25%;
        padding: 0 10px;
        box-sizing: border-box;
        text-align: center;
        display: flex;
        flex-direction: column;

        .item_gallery {
          width: 100%;
          position: relative;
          box-sizing: border-box;
          margin-bottom: 8px;
          a {
            display: inline-block;
            width: 100%;
          }
          .sale_tag {
            position: absolute;
            right: 0;
            top: 0;
            padding: 6px 12px;
            color: #fff;
            font-size: 12px;
            line-height: 14px;
            text-align: center;
            z-index: 1;
            background: #333;
          }
        }

        .item_name {
          margin: 0 auto;
          margin-bottom: 8px;
          width: 100%;
          a {
            display: inline-block;
            height: 48px;
            line-height: 24px;
            color: #666;
            font-size: 14px;
            text-decoration: none;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .oneline {
            height: 24px;
            display: inline-block;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .item_attribute {
          width: 100%;
          color: #737373;
          height: 40px;
          margin-bottom: 8px;
          .guesslike-select {
            width: 100%;
            height: 100%;
            border: 1px solid #dfdfdf;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            padding: 0 25px 0 10px;
            box-sizing: border-box;
            z-index: 1;
            position: relative;
            color: #737373;
            // border-radius: 4px;
            outline: 0;
            appearance: none;
            -webkit-appearance: none;
            line-height: 1;
            background-color: transparent;
            option {
              max-width: 100%;
            }
          }
        }
        .has_select {
          position: relative;
          &::after {
            font-family: iconfont !important;
            -webkit-font-smoothing: antialiased;
            content: "\E63C";
            font-size: 14px;
            position: absolute;
            right: 5px;
            top: 50%;
            transform: translateY(-50%);
            z-index: 999;
            pointer-events: none;
          }
        }
        .has_palette {
          height: unset !important;
          &::after {
            display: none;
          }
        }
        .item_price {
          text-align: center;
          margin: 0 auto;
          margin-bottom: 10px;
          padding: 0;
          font-weight: 600;
          .price {
            font-size: 14px;
            margin: 0 2px;
            font-weight: 700;
          }
          .regular_price {
            font-size: 14px;
            margin: 0 2px;
            text-decoration: line-through;
            color: rgb(123, 119, 130);
            display: inline-block;
          }
        }
        .item_star {
          -webkit-tap-highlight-color: transparent;
          height: 18px;
          display: inline-flex;
          justify-content: left;
          align-items: center;
          margin: 0 auto;
          margin-bottom: 8px;
        }
        .item_button {
          display: inline-block;
          line-height: 1;
          cursor: pointer;
          background: #fff;
          border: 1px solid #dcdfe6;
          text-align: center;
          box-sizing: border-box;
          transition: 0.1s;
          font-weight: 500;
          // border-radius: 4px;
          font-family: LatoRegular;
          background-color: rgba(255, 255, 255, 1);
          margin-bottom: 8px;
          padding: 15px 0;
          width: 100%;
          font-size: 14px;
          &--loading {
            cursor: auto;
            position: relative;
            overflow: hidden;
            &::before {
              display: inline-block;
              content: "";
              position: absolute;
              z-index: 1;
              height: 100%;
              width: 100%;
              background-color: #00000035;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
            }
            &::after {
              content: "";
              top: 50%;
              left: 50%;
              margin-top: -12px;
              margin-left: -12px;
              height: 24px;
              width: 24px;
              border-radius: 50vh;
              position: absolute;
              border-color: #fff;
              border-width: 2px;
              border-style: solid;
              border-top-color: transparent !important;
              animation: spin 1s infinite linear;
              z-index: 2;
            }
          }
        }
        #slodout {
          background-color: #969696 !important;
          border-color: #969696 !important;
          color: white !important;
          cursor: default !important;
          pointer-events: none;
        }
      }
    }
  }
}
.inline-guesslike {
  margin-bottom: 0;
  .guess_title {
    span {
      font-size: 14px !important;
    }
    em {
      font-size: 13px !important;
    }
  }
}
.athena-guess-ligke {
  .guess_list_wrap {
    & > .prev {
      left: 30px;
    }
    & > .next {
      right: 30px;
    }
    .guess_list_hidden {
      overflow: unset;
      .guess_list_box {
        .guess_list_item {
          width: 33.333%;
        }
      }
    }
  }
}
.swiper-command {
  width: 100%;
  bottom: -60px;
  text-align: center;
  line-height: 60px;
  ::v-deep {
    span {
      margin-right: 4px;
      width: 16px;
      height: 8px;
      border-radius: 4px;
    }
    .swiper-pagination-bullet-active {
      transition: width 0.5s;
      width: 32px;
      background: #000;
    }
  }
}
.m_hidden {
  display: none;
}
.attribute-pupup {
  position: absolute;
  bottom: 0;
  background-color: #FFFFFF;
  width: 100%;
  box-shadow: 0px 2px 16px 0px #f1f2f3;
  padding: 12px 12px 0 12px;
  z-index: 9;
  &__palette {
    position: relative;
    max-height: 248px;
    overflow: hidden;
    &:hover {
      overflow-y: auto;
    }
    > i {
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
      font-size: 13px;
    }
    &::-webkit-scrollbar {
      width: 3px;
      height: 3px;
      opacity: 0;
      transition: opacity 120ms ease-out;
      &:hover {
        opacity: 1;
      }
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(144, 147, 153, 0.3);
      transition: 0.3s background-color;
    }
    &::-webkit-scrollbar-track-piece {
      background-color: #fff;
    }
    &::v-deep {
      .variant_select {
        text-align: left;
        > label {
          padding-right: 10px;
          font-size: 14px;
          font-weight: 400;
        }
        .custom-swiper-prev,.custom-swiper-next {
          top: -8px !important;
          opacity: 0.5;
        }
        .custom-swiper-prev {
          justify-content: start !important;
        }
        .custom-swiper-next {
          justify-content: flex-end !important;
        }
        select {
          height: 40px !important;
          border-radius: 4px;
          border-color: #DDDDDD;
          &:focus-visible {
            border: 1px solid #1e0909 !important;
            outline: none;
          }
        }
        .default-select-dropdown {
          &::after {
            font-weight: bold;
            color: #222;
          }
        }
      }
      .labelStyleBox {
        .labelStyle {
          justify-content: left !important;
          flex-wrap: nowrap;
          .round,.fillet,.right_angle {
            div {
              min-width: 42px;
              min-height: 42px;
            }
          }
          .labelItem {
            label {
              margin-right: 10px;
              margin-bottom: 10px;
              text-align: center;
              vertical-align: middle;
            }
          }
        }
      }
    }
  }
  .item_button {
    width: calc(100% + 24px) !important;
    margin-left: -12px;
    margin-right: -12px;
  }

}
.attribute-pupup-mb {
  &__palette {
  position: relative;
  max-height: 50vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 20px;
  &::v-deep {
    .variant_select {
      text-align: left;
      padding-top: 12px;
      padding-bottom: 0;
      > label {
        margin-bottom: 12px;
        font-weight: 500;
      }
    }
    .labelStyleBox {
      .labelStyle {
        justify-content: left !important;
        .round,.fillet,.right_angle {
          div {
            min-width: 40px !important;
            min-height: 40px !important;
          }
        }
        .labelItem {
          label {
            padding: 15px 20px;
            margin-bottom: 12px;
            margin-right: 12px;
            font-size: 13px;
          }
        }
      }
    }
  }
  }
  &__button-box {
    padding: 20px;
    box-shadow: 0px 2px 8px 0px #DDDDDD;
  }
  &__item_button {
    display: inline-block;
    line-height: 1;
    cursor: pointer;
    background: #fff;
    border: 1px solid #dcdfe6;
    text-align: center;
    box-sizing: border-box;
    transition: 0.1s;
    font-weight: 500;
    font-family: LatoRegular;
    background-color: rgba(255, 255, 255, 1);
    padding: 14px 0;
    width: 100%;
    font-size: 14px;
    &--loading {
      cursor: auto;
      position: relative;
      overflow: hidden;
      &::before {
        display: inline-block;
        content: "";
        position: absolute;
        z-index: 1;
        height: 100%;
        width: 100%;
        background-color: #00000035;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }
      &::after {
        content: "";
        top: 50%;
        left: 50%;
        margin-top: -12px;
        margin-left: -12px;
        height: 24px;
        width: 24px;
        border-radius: 50vh;
        position: absolute;
        border-color: #fff;
        border-width: 2px;
        border-style: solid;
        border-top-color: transparent !important;
        animation: spin 1s infinite linear;
        z-index: 2;
      }
    }
  }
  &__head {
  display: flex;
  padding: 20px 20px 12px;
  .acpc-head-left {
    margin-right: 15px;
    width: 90px;
    min-width: 90px;
    max-width: 90px;
    height: 90px;
    background-color: #ececec;
    border-radius: 4px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .acpc-head-right {
    h5 {
      line-height: 18px;
      font-size: 14px;
      color: #222222;
      font-weight: 500;
    }
    h6 {
      margin-top: 7px;
      line-height: 1;
      font-size: 12px;
      color: #888888;
    }
    div {
      margin-top: 8px;
      font-size: 16px;
      font-weight: 400;
      color: #999999;
    }
  }
 }}
@media screen and(max-width:1480px) {
  .vogue-guess-ligke {
    .guess_list_wrap {
      & > .prev {
        left: -17px;
      }
      & > .next {
        right: -17px;
      }
      .guess_list_box {
        .guess_list_item {
          width: 33.33% !important;
          padding: 8px !important;
        }
      }
    }
  }
}
@media screen and(max-width: 768px) {
  .guess_like {
    .guess_title {
      text-align: left;
      span {
        font-size: 18px;
      }
    }
    .guess_list_wrap {
      & > .prev,
      & > .next {
        display: none !important;
      }
      .guess_list_box {
        .guess_list_item {
          width: 50% !important;
          padding: 8px;
        }
      }
    }
  }
  .vogue-guess-ligke {
    .guess_list_wrap {
      .guess_list_box {
        overflow-x: auto;
        .guess_list_item {
          width: 62% !important;
          padding: 8px !important;

          &:nth-child(1) {
            margin-left: 18%;
          }
          .item_name {
            a {
              height: 35px;
              line-height: 17px;
            }
          }
        }
      }
    }
  }
  .athena-guess-ligke {
    .guess_list_wrap {
      .guess_list_box {
        flex-wrap: wrap;
      }
    }
  }
}
</style>
